import { render, staticRenderFns } from "./Documentation_client.vue?vue&type=template&id=7d44c0b0&scoped=true"
import script from "./Documentation_client.vue?vue&type=script&lang=js"
export * from "./Documentation_client.vue?vue&type=script&lang=js"
import style0 from "./Documentation_client.vue?vue&type=style&index=0&id=7d44c0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d44c0b0",
  null
  
)

export default component.exports